const LEAD_FORM_EVENT = "leadform:open";

export const openLeadForm = () => {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(new Event(LEAD_FORM_EVENT));
};

export const leadFormEventName = LEAD_FORM_EVENT;
